const config = 'https://rpo.qqzhihui.cn'
const imgUrl = "https://rpo.qqzhihui.cn/"
export default{
    config,imgUrl
} 